import * as React from "react";
const SvgFiRrSearchLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-search-location_svg__a)">
      <path
        fill="#062147"
        d="m23.708 22.294-5.946-5.946a9.96 9.96 0 0 0 2.26-6.325c0-5.515-4.486-10.002-10-10.002s-10 4.487-10 10 4.485 10 10 10a9.95 9.95 0 0 0 6.324-2.26l5.947 5.945a.997.997 0 0 0 1.413 0 1 1 0 0 0 0-1.413zM2.02 10.022c0-4.412 3.59-8 8-8s8 3.588 8 8c0 4.41-3.589 8-8 8s-8-3.588-8-8M10.001 4a4.97 4.97 0 0 0-3.536 1.465A4.97 4.97 0 0 0 5 9c0 1.336.521 2.592 1.473 3.544l1.812 1.772a2.44 2.44 0 0 0 1.716.693 2.44 2.44 0 0 0 1.713-.693l1.822-1.78A4.97 4.97 0 0 0 15 9a4.97 4.97 0 0 0-1.465-3.535A4.97 4.97 0 0 0 10 4m2.129 7.114-1.814 1.772a.455.455 0 0 1-.632 0L7.88 11.122A2.98 2.98 0 0 1 7 8.999c0-.802.312-1.555.88-2.12a2.97 2.97 0 0 1 2.12-.88c.803 0 1.556.312 2.121.88a2.98 2.98 0 0 1 .88 2.12c0 .802-.313 1.556-.871 2.114M11 8.994a1 1 0 1 1-2-.001 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-search-location_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSearchLocation;
